module.exports = __webpack_public_path__ + "img/tet20204_mobile.1ba78786.png";